import {Module} from "../index";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {GameCreationEventSubscriber} from "./subscribers/GameCreationEventSubscriber";
import {ExpansionEventSubscriber} from "./subscribers/ExpansionEventSubscriber";
import {Stadium, StadiumLog, Terrace, TerraceLog} from "@/modules/stadium/entity";
import {TeamModule} from "@/modules/team";
import EntranceFeeChanger from "@/modules/stadium/services/EntranceFeeChanger";
import StadiumFoundationExpander from "@/modules/stadium/services/StadiumFoundationExpander";
import TerraceExpander from "@/modules/stadium/services/TerraceExpander";
import StadiumFactory from "@/modules/stadium/services/factories/StadiumFactory";
import TerraceFactory from "@/modules/stadium/services/factories/TerraceFactory";
import FoundationSeatLimitProvider from "@/modules/stadium/services/FoundationSeatLimitProvider";

export class StadiumModule extends Module {
  dependsOn = [
    TeamModule,
  ];

  messages = messages;
  routes = routes;

  public entities = [
    Stadium,
    Terrace,
    StadiumLog,
    TerraceLog,
  ];

  eventSubscribers = [
    GameCreationEventSubscriber,
    ExpansionEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<EntranceFeeChanger>(EntranceFeeChanger).to(EntranceFeeChanger).inSingletonScope();
    this.app.bind<StadiumFoundationExpander>(StadiumFoundationExpander).to(StadiumFoundationExpander).inSingletonScope();
    this.app.bind<TerraceExpander>(TerraceExpander).to(TerraceExpander).inSingletonScope();
    this.app.bind<FoundationSeatLimitProvider>(FoundationSeatLimitProvider).to(FoundationSeatLimitProvider).inSingletonScope();

    this.app.bind<TerraceFactory>(TerraceFactory).to(TerraceFactory).inSingletonScope();
    this.app.bind<StadiumFactory>(StadiumFactory).to(StadiumFactory).inSingletonScope();
  }
}
